/* global global process*/
import { isHidden } from '../lib/PageVisibility';

import Logger from './Logger';

const log = Logger.child({ component: 'tools/Globals' });

export let setTimeout;
export let clearTimeout;
export let document;
export let window;
export let navigator;
export let NODE_TESTING = false;
export const mockStore = {
  dispatch: () => {},
  getState: () => {},
};

export const IS_NODE = global && global.process && typeof process !== 'undefined';

export function addWindowEventListener(eventName, listener) {
  if (IS_NODE) {
    return;
  }
  window.addEventListener(eventName, listener);
}

export function createElement(type) {
  if (IS_NODE) {
    return;
  }
  return document.createElement(type);
}

export function removeWindowEventListener(eventName, listener) {
  if (IS_NODE) {
    return;
  }
  window.removeEventListener(eventName, listener);
}

export function addDocumentEventListener(eventName, listener, capture = false) {
  if (IS_NODE) {
    return;
  }
  document.addEventListener(eventName, listener, capture);
}

export function removeDocumentEventListener(eventName, listener, capture = false) {
  if (IS_NODE) {
    return;
  }
  document.removeEventListener(eventName, listener, capture);
}

export function backgroundSafeRequestAnimationFrame(callback) {
  if (IS_NODE) {
    return;
  }
  if (isHidden) {
    return callback();
  }
  return requestAnimationFrame(callback);
}

export function windowGA() {
  if (IS_NODE) {
    return;
  }
  if (!window.ga && process.env.NODE_ENV === 'development') {
    log.info('Google Analytics not loaded in development mode');
    return;
  }
  if (!window.ga && process.env.NODE_ENV !== 'test') {
    log.error('Google Analytics is undefined.');
    return;
  }
  return window.ga && window.ga(...arguments);
}

export function getDocumentLocationPathname() {
  return document.location.pathname;
}

export function matchMedia(mediaQuery) {
  if (IS_NODE) {
    return {
      matches: true,
    };
  }

  return window.matchMedia(mediaQuery);
}

export function getBranchInstance() {
  if (IS_NODE) {
    return;
  }

  return window.branch;
}

if (IS_NODE) {
  setTimeout = function (func) {
    func();
  };
  clearTimeout = global.clearTimeout;
  document = { body: { offsetHeight: 0, offsetWidth: 0 } };
  window = { innerHeight: 0, innerWidth: 0 };
  if (process.env.NODE_ENV === 'test') {
    NODE_TESTING = true;
  }
  navigator = {};
} else {
  // tricky, but global is supplied from webpack and is assigned to window
  // when not not in node env
  window = global;
  setTimeout = window.setTimeout.bind(window);
  clearTimeout = window.clearTimeout.bind(window);
  document = window.document;
  navigator = window.navigator;
}
